
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outcomes/[slug]",
      function () {
        return require("private-next-pages/outcomes/[slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outcomes/[slug]"])
      });
    }
  